import { render, staticRenderFns } from "./PhoneIndex.vue?vue&type=template&id=1da08cb0&scoped=true&"
import script from "./PhoneIndex.vue?vue&type=script&lang=js&"
export * from "./PhoneIndex.vue?vue&type=script&lang=js&"
import style0 from "./PhoneIndex.vue?vue&type=style&index=0&id=1da08cb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da08cb0",
  null
  
)

export default component.exports